<template>
  <div class="Vue-Toastification__toast-body">
    <span>Nova atualização de Ticket!</span>
    <button
      class="btn btn-sm btn-light btn-active-light-primary ms-6"
      @click="abrirTicket()"
    >
      Abrir
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    abrirTicket() {
      this.$emit("abrirTicket");
    },
  },
};
</script>
